/**
 * Created by rathompson on 9/28/21
 * File: DisplayNameRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import Link from '../../../../../common/components/link/Link'

/**
 *   Identity display name table cell
 */
const DisplayNameRenderer = ({ row, value, onClick }) => {
  return (
    <div className='tw-flex tw-w-full tw-h-full tw-p-1'>
      <Link {...{ onClick }}>
        { value }
      </Link>
    </div>
  )
}

DisplayNameRenderer.propTypes = {}
export default DisplayNameRenderer
